
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

function inlineSvg(size, sw, children) {
    return reactElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: (((((0 + " ") + 0) + " ") + 24) + " ") + 24,
        fill: "none",
        stroke: "currentColor",
        strokeWidth: sw,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

function svg16(size, children) {
    return inlineSvg(size, 1.6, children);
}

export function IconDatabase(size) {
    return svg16(size, ofArray([reactElement("ellipse", {
        cx: 12,
        cy: 5,
        rx: 9,
        ry: 3,
    }), reactElement("path", {
        d: "M3 5v14c0 1.66 4.03 3 9 3s9-1.34 9-3V5",
    }), reactElement("path", {
        d: "M3 12c0 1.66 4.03 3 9 3s9-1.34 9-3",
    })]));
}

export function IconUpload(size) {
    return svg16(size, ofArray([reactElement("path", {
        d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
    }), reactElement("polyline", {
        points: "17 8 12 3 7 8",
    }), reactElement("line", {
        x1: 12,
        y1: 3,
        x2: 12,
        y2: 15,
    })]));
}

export function IconCompass(size) {
    return svg16(size, ofArray([reactElement("circle", {
        cx: 12,
        cy: 12,
        r: 10,
    }), reactElement("polygon", {
        points: "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76",
    })]));
}

export function IconSparkles(size) {
    return svg16(size, singleton(reactElement("path", {
        d: "M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M6 18l2.5-2.5M15.5 8.5 18 6",
    })));
}

export function IconCheckmark(size) {
    return inlineSvg(size, 2.2, singleton(reactElement("path", {
        d: "m5 12 5 5 9-11",
    })));
}

export function IconArrowRight(size) {
    return svg16(size, ofArray([reactElement("path", {
        d: "M5 12h14",
    }), reactElement("path", {
        d: "m13 6 6 6-6 6",
    })]));
}

export function IconDownload(size) {
    return svg16(size, ofArray([reactElement("path", {
        d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
    }), reactElement("polyline", {
        points: "7 10 12 15 17 10",
    }), reactElement("line", {
        x1: 12,
        y1: 15,
        x2: 12,
        y2: 3,
    })]));
}

export function IconPlay(size) {
    return svg16(size, singleton(reactElement("polygon", {
        points: "5 3 19 12 5 21 5 3",
    })));
}

export function IconPlus(size) {
    return inlineSvg(size, 2, singleton(reactElement("path", {
        d: "M12 5v14M5 12h14",
    })));
}

export function IconChevronRight(size) {
    return svg16(size, singleton(reactElement("path", {
        d: "m9 18 6-6-6-6",
    })));
}

export function IconChevronLeft(size) {
    return svg16(size, singleton(reactElement("path", {
        d: "m15 18-6-6 6-6",
    })));
}

export function IconCalendar(size) {
    return svg16(size, ofArray([reactElement("rect", {
        x: 3,
        y: 4,
        width: 18,
        height: 18,
        rx: 2,
        ry: 2,
    }), reactElement("line", {
        x1: 16,
        y1: 2,
        x2: 16,
        y2: 6,
    }), reactElement("line", {
        x1: 8,
        y1: 2,
        x2: 8,
        y2: 6,
    }), reactElement("line", {
        x1: 3,
        y1: 10,
        x2: 21,
        y2: 10,
    })]));
}

export function IconPhone(size) {
    let path;
    return svg16(size, singleton(reactElement("path", createObj(singleton((path = "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.62 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.6a16 16 0 0 0 6 6l.96-.96a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z", ["d", path]))))));
}

export function IconMail(size) {
    return svg16(size, ofArray([reactElement("path", {
        d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z",
    }), reactElement("polyline", {
        points: "22,6 12,13 2,6",
    })]));
}

export function IconPackage(size) {
    let path;
    return svg16(size, ofArray([reactElement("path", createObj(singleton((path = "m16.5 9.4-9-5.19M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z", ["d", path])))), reactElement("polyline", {
        points: "3.29 7 12 12 20.71 7",
    }), reactElement("line", {
        x1: 12,
        y1: 22,
        x2: 12,
        y2: 12,
    })]));
}

export function IconRocket(size) {
    return svg16(size, ofArray([reactElement("path", {
        d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09Z",
    }), reactElement("path", {
        d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2Z",
    }), reactElement("path", {
        d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0",
    }), reactElement("path", {
        d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5",
    })]));
}

export function IconPaperclip(size) {
    return inlineSvg(size, 1.7, singleton(reactElement("path", {
        d: "M21 11.5l-8.5 8.5a5 5 0 01-7-7L14 4.5a3.5 3.5 0 015 5L10.5 18a2 2 0 01-3-3L15 7.5",
    })));
}

export function IconPaperPlane(size) {
    return inlineSvg(size, 1.9, singleton(reactElement("path", {
        d: "M22 2L11 13M22 2l-7 20-4-9-9-4z",
    })));
}

